export const PeopleContainer = () => `
<div class="people-all-container"></div>
`

export const SmallLayout = (data) => `
<div class="people-small-layout">
  <div class="people-header" id="people-header">
    <div class="people-header-left-inner" data-lang="people-text">
      ${data.people}
    </div>
    <div class="people-header-right-inner">
      <span class='material-icons clickable' id='peopleShrink'>fullscreen_exit</span>
      <span class='material-icons clickable' id='peopleExpand'>fullscreen</span>
      <span class='material-icons clickable' id='peopleClose'>close</span>
    </div>
  </div>
  <div class ="people-tabbed-wrapper">
   ${PeopleTabbedMenu(data)}
  </div>
  <div id="people-tour-scene-items-container" class="people-tab-active-scrollbale">
    <div class="people-list-wrapper">
    </div>
  </div>
  <div id="people-scene-items-container">
    <div class="people-list-wrapper">
    </div>
  </div>
  <div id="people-room-items-container">
    <div class="people-list-wrapper">
    </div>
  </div>
  <div id="people-friends-items-container">
    <div class="people-list-wrapper">
    </div>
  </div>
  ${Loading()}
</div>
`;


export const PeopleTabbedMenu = (data) => `
<div class="tabs is-fullwidth">
  <ul>
    <li id="tour-peopleTabScene" class="is-active">
      <a>
        <span><b data-lang="scene-text-chat">Tour</b> (0)</span>
      </a>
    </li>
    <li id="peopleTabScene" class="is-active">
      <a>
        <span><b data-lang="scene-text-chat">${data.scene}</b> (0)</span>
      </a>
    </li>
    <li id="peopleTabRoom">
      <a>
        <span><b data-lang="room-text">${data.room}</b> (0)</span>
      </a>
    </li>
    <li id="peopleTabFriends">
      <a>
        <span><b data-lang="friends-text">${data.friends}</b> (0)</span>
      </a>
    </li>
  </ul>
</div>
`;

export const PeopleListItemSmall = (data) => `
<div class="people-list-item-wrapper" data-user-id="${data.userId}">
  <div class="people-list-item-content-wrapper">
    <div class="people-list-item-image">
      <img class="other-user-avatar no-border" src="${data.userAvatarUrl}" alt="Image">
    </div >
    <div class="people-list-item-name">
      <div>${data.userName || data.name}</div>
    </div>
    <div class="people-list-item-icons clickable">
    <svg id="peopleChatIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.305 22.5L12 21.75L15 16.5H19.5C19.8978 16.5 20.2794 16.342 20.5607 16.0607C20.842 15.7794 21 15.3978 21 15V6C21 5.60218 20.842 5.22064 20.5607 4.93934C20.2794 4.65804 19.8978 4.5 19.5 4.5H4.5C4.10218 4.5 3.72064 4.65804 3.43934 4.93934C3.15804 5.22064 3 5.60218 3 6V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H11.25V18H4.5C3.70435 18 2.94129 17.6839 2.37868 17.1213C1.81607 16.5587 1.5 15.7956 1.5 15V6C1.5 5.20435 1.81607 4.44129 2.37868 3.87868C2.94129 3.31607 3.70435 3 4.5 3H19.5C20.2956 3 21.0587 3.31607 21.6213 3.87868C22.1839 4.44129 22.5 5.20435 22.5 6V15C22.5 15.7956 22.1839 16.5587 21.6213 17.1213C21.0587 17.6839 20.2956 18 19.5 18H15.87L13.305 22.5Z" fill="#8D8D8B"/>
      <path d="M6 7.5H18V9H6V7.5ZM6 12H13.5V13.5H6V12Z" fill="#8D8D8B"/>
    </svg>
    <svg  id='peopleVideoChat' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 8V16H5V8H15ZM16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.45 16.55 6 16 6Z" fill="#8D8D8B"/>
    </svg>
    <svg id="peopleAddFriend" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C12.79 4 11 5.79 11 8C11 10.21 12.79 12 15 12ZM15 6C16.1 6 17 6.9 17 8C17 9.1 16.1 10 15 10C13.9 10 13 9.1 13 8C13 6.9 13.9 6 15 6ZM15 14C12.33 14 7 15.34 7 18V20H23V18C23 15.34 17.67 14 15 14ZM9 18C9.22 17.28 12.31 16 15 16C17.7 16 20.8 17.29 21 18H9ZM6 15V12H9V10H6V7H4V10H1V12H4V15H6Z" fill="#8D8D8B"/>
    </svg>

    </svg>
    <svg id="peopleOptionsMenu" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" fill="#8D8D8B"/>
      </svg>
    ${SceneThreeDotsMenu(data)}
    </div>
  </div >
</div >
  `;
///item inside people list
export const PeopleListItemSmallIsUser = (data) => `
<div class="people-list-item-wrapper" data-user-id=${data.userId}>
  <div class="people-list-item-content-wrapper">
    <div class="people-list-item-image">
      <img class="other-user-avatar no-border" src="${data.userAvatarUrl}" alt="Image">
    </div >
    <div class="people-list-item-name">
      <div data-lang="you-text">${data.you}</div>
    </div>
    <div class="people-list-item-icons clickable">
        <svg id="peopleOptionsMenu" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" fill="#8D8D8B"/>
        </svg>
         ${IsUserThreeDotsMenu(data)}
    </div>
  </div >
</div >
  `;
///same as above without SVG
export const RoomListItemSmall = (data) => `
<div class="people-list-item-wrapper" data-user-id=${data.userId}>
  <div class="people-list-item-content-wrapper">
    <div class="people-list-item-image">
      <img class="other-user-avatar no-border" src="${data.userAvatarUrl}" alt="Image">
    </div >
      <div class="people-list-item-name-small">
        <div>${data.userName || data.name}</div>
        <div class="people-list-item-name-scene-name">${data.currentSceneName || ''}</div>
      </div>
    <div class="people-list-item-icons clickable">
      <svg id="peopleIsFriendIcon" style="transform: scale(.65) ;" width="24" height="24" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10.689L11.326 13.3L10.178 8.379L14 5.068L8.967 4.641L7 0L5.033 4.641L0 5.068L3.822 8.379L2.674 13.3L7 10.689Z" fill="#FE9000"/>
      </svg>
      <svg id="peopleChatIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.305 22.5L12 21.75L15 16.5H19.5C19.8978 16.5 20.2794 16.342 20.5607 16.0607C20.842 15.7794 21 15.3978 21 15V6C21 5.60218 20.842 5.22064 20.5607 4.93934C20.2794 4.65804 19.8978 4.5 19.5 4.5H4.5C4.10218 4.5 3.72064 4.65804 3.43934 4.93934C3.15804 5.22064 3 5.60218 3 6V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H11.25V18H4.5C3.70435 18 2.94129 17.6839 2.37868 17.1213C1.81607 16.5587 1.5 15.7956 1.5 15V6C1.5 5.20435 1.81607 4.44129 2.37868 3.87868C2.94129 3.31607 3.70435 3 4.5 3H19.5C20.2956 3 21.0587 3.31607 21.6213 3.87868C22.1839 4.44129 22.5 5.20435 22.5 6V15C22.5 15.7956 22.1839 16.5587 21.6213 17.1213C21.0587 17.6839 20.2956 18 19.5 18H15.87L13.305 22.5Z" fill="#8D8D8B"/>
        <path d="M6 7.5H18V9H6V7.5ZM6 12H13.5V13.5H6V12Z" fill="#8D8D8B"/>
      </svg>
      <svg  id='peopleVideoChat' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 8V16H5V8H15ZM16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.45 16.55 6 16 6Z" fill="#8D8D8B"/>
      </svg>
      <svg id="peopleOptionsMenu" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" fill="#8D8D8B"/>
      </svg>
      ${PeopleThreeDotsMenu(data)}
    </div>
  </div>
</div >
  `;
///item inside people list
export const roomListItemSmallIsUser = (data) => `
<div class="people-list-item-wrapper" data-user-id=${data.userId}>
  <div class="people-list-item-content-wrapper">
    <div class="people-list-item-image">
      <img class="other-user-avatar no-border" src="${data.userAvatarUrl}" alt="Image">
    </div >
    <div class="people-list-item-name">
      <div data-lang="you-text">${data.you}</div>
       <div class="people-list-item-name-scene-name">${data.currentSceneName || ''}</div>
    </div>
    <div class="people-list-item-icons clickable">
    </div>
  </div >
</div >
  `;

export const PeopleThreeDotsMenu = (data) => {
  return `
  <div class ="people-box-container">
    <div class="box" id="peopleJumpToScene" data-lang="jump-to-scene-text" user-id="${data.userId}">
      ${data.jumpToSceneText}
    </div>
    <div class="box" id="peopleInviteToScene" data-lang="invite-to-scene-text">
    ${data.inviteToSceneText}
    </div>
    <div class="box" id="peopleAddAsFriend" data-lang="add-as-friend-text">
    ${data.addAsFriendText}
    </div>
        <div class="box" id="peopleRemoveFromFriends" data-lang="remove-as-friend-text">
      ${data.removeFromFriendsText}
    </div>
    <div class="box" id="showUserInfo-peopleList" data-lang="show-user-info-text">
    ${data.showUserInfo}
    </div>
    <div class="box" id="inviteToTour-peopleList" data-lang="invite-tour-user-info-text">
    ${data.inviteToTourInfo}
    </div>
  </div>
  `
}
export const IsUserThreeDotsMenu = (data) => {
  return `
  <div class ="people-box-container">
    <div class="box" id="showUserInfo-peopleList" data-lang="show-user-info-text">
    ${data.showUserInfo}
    </div>
  </div>
  `
};

export const TourScene3Dots = (data) => {
  return `
  <div class ="people-box-container">
    <div class="box" id="tour-invite-people-as-guest" data-lang="tour-invite-to-chair">
      Invite User to tour chair
    </div>
  </div>
  `
};

export const SceneThreeDotsMenu = (data) => {
  return `
  <div class ="people-box-container">
    <div class="box" id="peopleAddAsFriend" data-lang="add-as-friend-text">
      ${data.addAsFriendText}
    </div>
    <div class="box" id="peopleRemoveFromFriends" data-lang="remove-as-friend-text">
      ${data.removeFromFriendsText}
    </div>
    <div class="box" id="showUserInfo-peopleList" data-lang="show-user-info-text">
      ${data.showUserInfo}
    </div>
  </div>
  `
}

//*<div class="box" id="peopleRemoveFromFriends"> Remove from friends </div> *//



////people icon for openening panel
export const PeopleIcon = (data) => `
<div class="people-open-people-chat-wrapper">
  <div class="people-icon-wrapper">
    <div class="people-icon-notification-wrapper">
      <div class="people-icon-notification-text" id="people-icon-counter">
        10
      </div>
    </div>
    <div class="people-icon-images-wrapper">
    </div>
  </div>
  <span class="tooltip" data-lang="people-text">${data.peopleText}</span>
</div>
`;

export const PeopleIconImage = (data) => `
  <div class="people-icon-image-wrapper">
    <img src="${data.userAvatarUrl}" alt="Image">
  </div>
`;
export const PeopleIconSvg = (data) => `
  <div class="people-icon-image-wrapper" id="people-list-icon-button">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.67 13.13C18.04 14.06 19 15.32 19 17V20H23V17C23 14.82 19.43 13.53 16.67 13.13Z" fill="#8D8D8B"/>
    <path d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z" fill="#8D8D8B"/>
    <path d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z" fill="#8D8D8B"/>
    <path d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z" fill="#8D8D8B"/>
    </svg>
    <div class="people-icon-warning-icon scale-up-center">
      ${WarningIcon()}
    </div>
  </div>
`;



///Offline friend list item
export const OfflineFriendListItem = (data) => {
  return `
<div class="people-list-item-wrapper" data-user-id="${data.id}">
  <div class="people-list-item-content-wrapper">
    <div class="people-list-item-image offline">
      <img class="other-user-avatar no-border" src="${data.userAvatarUrl || data.avatar_image_url}" alt="Image">
    </div>
    <div class="people-list-item-name-small offline">
      <div>${data.userName || data.name || data.username}</div>
      <div class="people-list-item-name-scene-name">Offline</div>
    </div>
    <div class="people-list-item-icons">
    <svg id="peopleChatIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.305 22.5L12 21.75L15 16.5H19.5C19.8978 16.5 20.2794 16.342 20.5607 16.0607C20.842 15.7794 21 15.3978 21 15V6C21 5.60218 20.842 5.22064 20.5607 4.93934C20.2794 4.65804 19.8978 4.5 19.5 4.5H4.5C4.10218 4.5 3.72064 4.65804 3.43934 4.93934C3.15804 5.22064 3 5.60218 3 6V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H11.25V18H4.5C3.70435 18 2.94129 17.6839 2.37868 17.1213C1.81607 16.5587 1.5 15.7956 1.5 15V6C1.5 5.20435 1.81607 4.44129 2.37868 3.87868C2.94129 3.31607 3.70435 3 4.5 3H19.5C20.2956 3 21.0587 3.31607 21.6213 3.87868C22.1839 4.44129 22.5 5.20435 22.5 6V15C22.5 15.7956 22.1839 16.5587 21.6213 17.1213C21.0587 17.6839 20.2956 18 19.5 18H15.87L13.305 22.5Z" fill="#8D8D8B"/>
      <path d="M6 7.5H18V9H6V7.5ZM6 12H13.5V13.5H6V12Z" fill="#8D8D8B"/>
    </svg>
    <svg id="peopleOptionsMenu" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" fill="#8D8D8B"/>
    </svg>
    ${PeopleThreeDotsMenuAreFriendsOffline(data)}
    </div>
  </div>
</div>
  `};

///
export const PendingRoomListItemSmall = (data) => `
<div class="people-list-item-wrapper" data-user-id="${data.userId}">
  <div class="people-list-item-content-wrapper">
    <div class="people-list-item-image">
      <img class="other-user-avatar no-border" src="${data.userAvatarUrl}" alt="${data.imageAlt}" data-lang="image-alt">
    </div >
    <div class="people-list-item-name-small">
      <div>${data.userName || data.name}</div>
      <div class="people-list-item-name-scene-name"data-lang="online-text">${data.currentSceneName || ''}</div>
    </div>
    <div class="people-list-item-icons clickable">
    <svg id="peopleChatIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.305 22.5L12 21.75L15 16.5H19.5C19.8978 16.5 20.2794 16.342 20.5607 16.0607C20.842 15.7794 21 15.3978 21 15V6C21 5.60218 20.842 5.22064 20.5607 4.93934C20.2794 4.65804 19.8978 4.5 19.5 4.5H4.5C4.10218 4.5 3.72064 4.65804 3.43934 4.93934C3.15804 5.22064 3 5.60218 3 6V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H11.25V18H4.5C3.70435 18 2.94129 17.6839 2.37868 17.1213C1.81607 16.5587 1.5 15.7956 1.5 15V6C1.5 5.20435 1.81607 4.44129 2.37868 3.87868C2.94129 3.31607 3.70435 3 4.5 3H19.5C20.2956 3 21.0587 3.31607 21.6213 3.87868C22.1839 4.44129 22.5 5.20435 22.5 6V15C22.5 15.7956 22.1839 16.5587 21.6213 17.1213C21.0587 17.6839 20.2956 18 19.5 18H15.87L13.305 22.5Z" fill="#8D8D8B"/>
      <path d="M6 7.5H18V9H6V7.5ZM6 12H13.5V13.5H6V12Z" fill="#8D8D8B"/>
    </svg>
    <svg  id='peopleVideoChat' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 8V16H5V8H15ZM16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.45 16.55 6 16 6Z" fill="#8D8D8B"/>
    </svg>
    <svg id="peopleOptionsMenu" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" fill="#8D8D8B"/>
    </svg>
     ${PeopleThreeDotsMenuAreFriends(data)}
    </div>
  </div>
</div >
  `;

export const PeopleThreeDotsMenuAreFriends = (data) => {
  return `
  <div class ="people-box-container">
    <div class="box" id="peopleJumpToSceneGlobal" data-lang="jump-to-scene-text">
      ${data.jumpToSceneText || "Jump to scene"}
    </div>
    <div class="box" id="peopleInviteToSceneGlobal" data-user-id-global="${data.userId}">
      ${data.inviteToSceneText || "Invite to scene"}
    </div>
    <div class="box" id="showUserInfo-friendsList" data-lang="show-user-info-text">
      ${data.showUserInfo || "Show user info"} 
    </div>
    <div class="box" id="inviteToTour-peopleList" data-lang="Invite to tour">
      ${data.showUserInfo || "Invite to tour"} 
    </div>
    <div class="box" id="peopleRemoveFromFriends" data-lang="remove-from-friends-text">
      ${data.removeFromFriendsText || "Remove from friends"} 
    </div>
  </div>
  `
}

export const PeopleThreeDotsMenuAreFriendsOffline = (data) => {
  return `
  <div class ="people-box-container">
    <div class="box" id="peopleRemoveFromFriends" data-lang="remove-from-friends-text">
      ${data.removeFromFriendsText || "Remove from friends"} 
    </div>
    <div class="box" id="showUserInfo-friendsList" data-lang="show-user-info-text">
      ${data.showUserInfo || "Show user info"}
    </div>
  </div>
  `
}


export const Loading = () => {
  return `
  <div class ="scene-items-loading-container">
    <div class="scene-tiems-loading-text-wrapper">
      <div>
        Connecting to services...
      </div>
      <div class="">
        <span class='material-icons rotate-center'>hourglass_empty</span>
      </div>
    <div>
  </div>
  `
}


export const WarningIcon = () => {
  return `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 4C7.584 4 4 7.584 4 12C4 16.416 7.584 20 12 20C16.416 20 20 16.416 20 12C20 7.584 16.416 4 12 4ZM12.8 16H11.2V14.4H12.8V16ZM12.8 12.8H11.2V8H12.8V12.8Z" fill="#8D8D8B"/>
    </svg>
  `
}



///same as above without SVG
export const TourSceneItem = (data) => `
<div class="people-list-item-wrapper" data-user-id="${data.userId}">
  <div class="people-list-item-content-wrapper">
    <div class="people-list-item-image">
      <img class="other-user-avatar no-border" src="${data.userAvatarUrl}" alt="Image">
    </div >
      <div class="people-list-item-name-small">
        <div>${data.userName || data.name} <span id='raised-hand' class='material-icons-outlined'>back_hand</span></div>
        <div class="people-list-item-name-scene-name">${data.currentSceneName || ''}</div>
      </div>
    <div class="people-list-item-icons clickable">
      <svg id="peopleChatIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.305 22.5L12 21.75L15 16.5H19.5C19.8978 16.5 20.2794 16.342 20.5607 16.0607C20.842 15.7794 21 15.3978 21 15V6C21 5.60218 20.842 5.22064 20.5607 4.93934C20.2794 4.65804 19.8978 4.5 19.5 4.5H4.5C4.10218 4.5 3.72064 4.65804 3.43934 4.93934C3.15804 5.22064 3 5.60218 3 6V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H11.25V18H4.5C3.70435 18 2.94129 17.6839 2.37868 17.1213C1.81607 16.5587 1.5 15.7956 1.5 15V6C1.5 5.20435 1.81607 4.44129 2.37868 3.87868C2.94129 3.31607 3.70435 3 4.5 3H19.5C20.2956 3 21.0587 3.31607 21.6213 3.87868C22.1839 4.44129 22.5 5.20435 22.5 6V15C22.5 15.7956 22.1839 16.5587 21.6213 17.1213C21.0587 17.6839 20.2956 18 19.5 18H15.87L13.305 22.5Z" fill="#8D8D8B"/>
        <path d="M6 7.5H18V9H6V7.5ZM6 12H13.5V13.5H6V12Z" fill="#8D8D8B"/>
      </svg>
      <svg  id="peopleAddAsTourContributore" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.67 13.13C18.04 14.06 19 15.32 19 17V20H23V17C23 14.82 19.43 13.53 16.67 13.13Z" fill="#8D8D8B"/>
      <path d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z" fill="#8D8D8B"/>
      <path d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z" fill="#8D8D8B"/>
      <path d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z" fill="#8D8D8B"/>
      </svg>  
      <svg id="peopleOptionsMenu" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" fill="#8D8D8B"/>
      </svg>
      ${TourScene3Dots(data)}
    </div>
  </div>
</div >
  `;
